import { useEffect, useRef } from 'react'

/**
 * Subscribes to the event's SSE stream and invokes a handler on each change
 * signal. The handler receives the parsed payload (e.g. { kind: 'agenda' } or
 * { kind: 'notification', title, body, url }). Auto-reconnects on error.
 */
export function useEventStream(
  eventId: string | null | undefined,
  onChange: (data: { kind: string; [k: string]: unknown }) => void,
) {
  const handlerRef = useRef(onChange)
  handlerRef.current = onChange

  useEffect(() => {
    if (!eventId) return
    // SSE endpoint is same-origin; the browser sends cookies automatically.
    const es = new EventSource(`/api/events/${eventId}/stream`)
    es.addEventListener('change', (e) => {
      try {
        handlerRef.current(JSON.parse((e as MessageEvent).data))
      } catch {
        /* ignore malformed */
      }
    })
    return () => es.close()
  }, [eventId])
}
